import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";

/**
 * The error banner above the login and signup cards. `action` is where the
 * cross-link goes when the visitor is simply on the wrong page — an unknown
 * email on /login, an already-registered one on /signup.
 */
export function AuthErrorBanner({
  message,
  action,
}: {
  message: string;
  action?: ReactNode;
}) {
  return (
    <div
      role="alert"
      className="rounded-xl border border-red-200 bg-red-50/50 backdrop-blur-sm p-3.5 flex items-start gap-3 animate-in slide-in-from-top-2 duration-200"
    >
      <AlertCircle className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />
      <div className="space-y-1">
        <p className="text-sm font-medium text-red-800">{message}</p>
        {action}
      </div>
    </div>
  );
}
